module.exports = __webpack_public_path__ + "static/img/GH@3x.f990bc13.jpg";